import { render } from "./arrow_down2_tr.svg.vue?vue&type=template&id=468969e8"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__